import ResourceService from "./resource.service";

class ContractRouteService extends ResourceService {
  static get resource() {
    return "contract-route";
  }

  static previewVehicleSync(routeId, data) {
    return this.post(data, `${routeId}/vehicle-sync-preview`);
  }

  static applyVehicleSync(routeId, data) {
    return this.put(data, `${routeId}/vehicle-sync`);
  }

  static getDeactivationSummary(routeId) {
    return this.get(`${routeId}/deactivation-summary`);
  }

  static deactivate(routeId) {
    return this.put({}, `${routeId}/deactivate`);
  }
}

export default ContractRouteService;
